export const SETTLEMENTS_RESET_STATE = 'SETTLEMENTS_RESET_STATE';
export const SETTLEMENTS_CURRENT_ITEM = 'SETTLEMENTS_CURRENT_ITEM';

export const SETTLEMENTS_REQUEST_LOADING = 'SETTLEMENTS_REQUEST_LOADING';
export const SETTLEMENTS_REQUEST_SUCCESS = 'SETTLEMENTS_REQUEST_SUCCESS';
export const SETTLEMENTS_REQUEST_FAILED = 'SETTLEMENTS_REQUEST_FAILED';

export const SETTLEMENTS_CURRENT_ACTION = 'SETTLEMENTS_CURRENT_ACTION';
export const SETTLEMENTS_RESET_ACTION = 'SETTLEMENTS_RESET_ACTION';